"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var FilterDrawer_1 = __importDefault(require("../../../../app/components/FilterDrawer"));
var ArrowDownIcon_1 = __importDefault(require("../../../../app/components/widgets/ArrowDownIcon"));
var CloseIcon_1 = __importDefault(require("../../../../app/components/widgets/CloseIcon"));
var SearchSortIcon_1 = __importDefault(require("../../../../app/components/widgets/SearchSortIcon"));
var SearchIcon_1 = __importDefault(require("../../../../app/components/widgets/SearchIcon"));
var EmailIcon_1 = __importDefault(require("../../../../app/components/widgets/EmailIcon"));
var constants_1 = require("../../../constants");
var SortDrawer_1 = __importDefault(require("./SortDrawer"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g;
    return core_1.createStyles({
        root: (_a = {
                width: '100%',
                height: '44px'
            },
            _a[theme.breakpoints.up('md')] = {
                height: '70px',
            },
            _a),
        searchTextField: {
            width: '100%',
            height: '100%',
            '& input::-webkit-search-decoration, & input::-webkit-search-cancel-button, & input::-webkit-search-results-button, & input::-webkit-search-results-decoration': {
                display: 'none',
            },
        },
        searchInput: (_b = {
                height: '100%',
                background: 'white',
                boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.25)',
                borderRadius: '5px',
                border: 0,
                paddingRight: 0,
                paddingLeft: 0
            },
            _b[theme.breakpoints.up('md')] = {
                paddingRight: theme.spacing(2),
            },
            _b),
        searchInputNested: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                fontSize: '1rem',
            },
            _c),
        searchInputIcon: (_d = {
                marginTop: '6px',
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(1)
            },
            _d[theme.breakpoints.up('md')] = {
                marginLeft: theme.spacing(4),
                marginRight: theme.spacing(2.5),
            },
            _d),
        searchbar: {
            display: 'contents',
        },
        searchOptionsButton: (_e = {
                padding: theme.spacing(0.75),
                marginRight: theme.spacing(1.5)
            },
            _e[theme.breakpoints.up('md')] = {
                marginRight: theme.spacing(2.5),
                padding: theme.spacing(1.5),
            },
            _e),
        closeButton: (_f = {
                padding: theme.spacing(0.75)
            },
            _f[theme.breakpoints.up('md')] = {
                padding: theme.spacing(1.5),
            },
            _f),
        sortPanel: {
            width: theme.spacing(50),
            right: 0,
            left: 'auto',
        },
        filterButton: {
            height: '100%',
            paddingLeft: '30px',
            paddingRight: '30px',
            borderRadius: '0px',
        },
        filterIcon: (_g = {
                paddingLeft: theme.spacing(0.5),
                verticalAlign: 'middle'
            },
            _g[theme.breakpoints.down('sm')] = {
                paddingLeft: theme.spacing(0.0),
            },
            _g),
        buttonWrapper: {
            width: 'auto',
            display: 'inline-flex',
        },
        labelWrapper: {
            verticalAlign: 'middle',
        },
    });
});
var noOp = function () { };
/**
 * @component Search bar with filter panel and sort panel.
 */
var DirectoryInput = function (_a) {
    var showAdornments = _a.showAdornments, query = _a.query, _b = _a.onQueryChange, onQueryChange = _b === void 0 ? noOp : _b, _c = _a.onSortOrderChange, onSortOrderChange = _c === void 0 ? noOp : _c, _d = _a.onClearQuery, onClearQuery = _d === void 0 ? noOp : _d, _e = _a.onKeyPress, onKeyPress = _e === void 0 ? noOp : _e, _f = _a.getFile, getFile = _f === void 0 ? noOp : _f, _g = _a.getState, getState = _g === void 0 ? noOp : _g, _h = _a.getEmail, getEmail = _h === void 0 ? noOp : _h, _j = _a.onApply, onApply = _j === void 0 ? noOp : _j, _k = _a.onReset, onReset = _k === void 0 ? noOp : _k, _l = _a.setDisablePagination, setDisablePagination = _l === void 0 ? noOp : _l;
    var _m = __read(react_1.useState(false), 2), isSortPanelOpen = _m[0], setIsSortPanelOpen = _m[1];
    var _o = __read(react_1.useState(false), 2), isFilterOpen = _o[0], setIsFilterOpen = _o[1];
    var _p = __read(react_1.useState(false), 2), isEmail = _p[0], setIsEmail = _p[1];
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    // Checks and assign email variable
    react_1.useEffect(function () {
        if (isEmail) {
            getEmail('true');
        }
        else {
            getEmail('false');
        }
    }, [isEmail]);
    // If sort panel is open, set pagination z-index to -1, else reset z-index to 1
    // this prevent pagination from intersecting with sort panel
    react_1.useEffect(function () {
        if (isSortPanelOpen) {
            setDisablePagination(true);
        }
        else {
            setDisablePagination(false);
        }
    }, [isSortPanelOpen]);
    // Label for the button - requires double conditions
    var getSearchLabel = function () {
        if (isMobileView && isEmail) {
            return react_1.default.createElement(EmailIcon_1.default, { size: 20 });
        }
        if (isMobileView && !isEmail) {
            return react_1.default.createElement(SearchIcon_1.default, { size: 20 });
        }
        if (!isMobileView && isEmail) {
            return 'Email';
        }
        return 'Keyword';
    };
    // Icon for search bar
    var getSearchIcon = function () {
        if (isMobileView) {
            return '';
        }
        if (isEmail) {
            return react_1.default.createElement(EmailIcon_1.default, { size: isMobileView ? 30 : 30 });
        }
        return react_1.default.createElement(SearchIcon_1.default, { size: isMobileView ? 30 : 30 });
    };
    return (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: function () {
            if (!isMobileView) {
                setIsSortPanelOpen(false);
            }
            setIsFilterOpen(false);
            setDisablePagination(false);
        } },
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(core_1.TextField, { autoFocus: true, type: "search", className: classes.searchTextField, placeholder: isEmail
                    ? 'Enter an email or email domain e.g. @mom.gov.sg'
                    : 'Enter a keyword', value: query, onChange: function (e) { return onQueryChange(e.target.value); }, onKeyPress: onKeyPress, variant: "outlined", InputProps: {
                    className: classes.searchInput,
                    startAdornment: (react_1.default.createElement("div", { className: classes.searchbar },
                        react_1.default.createElement(core_1.Button, { className: classes.filterButton, onClick: function () { return setIsFilterOpen(!isFilterOpen); } },
                            react_1.default.createElement("div", { className: classes.buttonWrapper },
                                isMobileView ? (getSearchLabel()) : (react_1.default.createElement("span", { className: classes.labelWrapper }, getSearchLabel())),
                                isMobileView ? (react_1.default.createElement(ArrowDownIcon_1.default, { className: classes.filterIcon, height: "20", width: "20" })) : (react_1.default.createElement(ArrowDownIcon_1.default, { className: classes.filterIcon, height: "24", width: "24" })))),
                        react_1.default.createElement(core_1.Divider, { orientation: "vertical", flexItem: true }),
                        react_1.default.createElement("div", { className: classes.searchInputIcon }, getSearchIcon()))),
                    endAdornment: (react_1.default.createElement(react_1.default.Fragment, null, showAdornments && (react_1.default.createElement(react_1.default.Fragment, null,
                        query && (react_1.default.createElement(core_1.IconButton, { onClick: onClearQuery, className: classes.closeButton },
                            react_1.default.createElement(CloseIcon_1.default, { size: isMobileView ? 20 : 24, color: "#BBBBBB" }))),
                        react_1.default.createElement(core_1.IconButton, { className: classes.searchOptionsButton, onClick: function () { return setIsSortPanelOpen(true); } },
                            react_1.default.createElement(SearchSortIcon_1.default, { size: isMobileView ? 20 : 30 })))))),
                }, 
                // TextField takes in two separate inputProps and InputProps,
                // each having its own purpose.
                // eslint-disable-next-line react/jsx-no-duplicate-props
                inputProps: {
                    className: classes.searchInputNested,
                    onClick: function () { return setIsSortPanelOpen(false); },
                } }),
            react_1.default.createElement(FilterDrawer_1.default, { labels: ['Keyword', 'Email'], selectedLabel: isEmail ? 'Email' : 'Keyword', onClick: function (label) {
                    setIsEmail(label === 'Email');
                }, isFilterOpen: isFilterOpen, isMobileView: isMobileView, setIsFilterOpen: setIsFilterOpen }),
            react_1.default.createElement(SortDrawer_1.default, { open: isSortPanelOpen, onClose: function () { return setIsSortPanelOpen(false); }, onChoose: onSortOrderChange, options: constants_1.sortOptions, getFile: getFile, getState: getState, onApply: onApply, onReset: onReset }))));
};
exports.default = DirectoryInput;
